module.exports = __webpack_public_path__ + "media/images/profile-photo-placeholder-f7458b09a30505d18595d4719f4f8f51.svg";